import React, { useState } from "react"
import { mutationRequest } from "../../util/request"
import { Button } from "../../components/shared/Button"
import { DeleteWarningGauntlet } from "../../components/shared/DeleteWarningGauntlet"
import { Band } from "../../types/bands"

interface BandDeleteFormProps {
  band: Band
}

interface DeleteResponse {
  success?: boolean
}

export const BandDeleteForm: React.FC<BandDeleteFormProps> = ({ band }) => {
  const [disabled, setDisabled] = useState<boolean>(false)

  const handleDeleteBand = () => {
    setDisabled(true)
    deleteBand(band.id).then(redirectHome)
  }

  return (
    <DeleteWarningGauntlet subject={band.name}>
      <Button
        disabled={disabled}
        bg="bg-red-600"
        className="hover:bg-red-700"
        onClick={(e) => {
          if (
            window.confirm(
              `Are you sure to delete all band data for ${band.name}?`,
            )
          ) {
            handleDeleteBand()
          }
        }}
      >
        Delete {band.name}
      </Button>
    </DeleteWarningGauntlet>
  )
}

export const deleteBand = async (
  bandId: number,
): Promise<DeleteResponse | undefined> => {
  try {
    let responseData = await mutationRequest({
      path: `/api/v1/bands/${bandId}`,
      options: { method: "DELETE" },
    })
    return responseData
  } catch (error) {
    console.log("Error attempting to delete band: ", error)
  }
}

export const redirectHome = (): void => {
  window.location.href = "/"
}
